<template>
  <div>
    <div v-if="currentBankHasBinding" class="top-banner">
      <div class="top-banner__item">
        <div
          v-if="couponImgForTOConfig.hasBind"
          class="top-banner__item__redEnvelop"
          :style="{ backgroundImage: 'url(' + couponImgForTOConfig.hasBind.redEnvelop + ')' }"
        ></div>
        <div class="top-banner__item__content">
          <div class="top-banner__item__content--title">
            数字人民币优惠券包
          </div>
          <div class="top-banner__item__content--subTitle">
            已发放至数币App-服务-红包
          </div>
        </div>
        <div
          v-if="topBannerButtonImg"
          class="top-banner__item__button"
          :style="{ backgroundImage: 'url(' + topBannerButtonImg + ')' }"
          @click="toDcepApp"
        ></div>
      </div>
      <div class="top-banner__item">
        <div
          v-if="couponImgForTOConfig.hasBind"
          class="top-banner__item__redEnvelop"
          :style="{ backgroundImage: 'url(' + couponImgForTOConfig.hasBind.coupon + ')' }"
        ></div>
        <div class="top-banner__item__content">
          <div class="top-banner__item__content--title">美团消费券包</div>
          <div class="top-banner__item__content--subTitle">
            已发放至美团-数字人⺠币专区-现金券
          </div>
        </div>
        <div
          v-if="topBannerButtonImg"
          class="top-banner__item__button"
          :style="{ backgroundImage: 'url(' + topBannerButtonImg + ')' }"
          @click="toEcnyHome"
        ></div>
      </div>
    </div>
    <div
      v-if="!currentBankHasBinding && topbannerImage"
      class="top-banner2"
      :style="{ backgroundImage: 'url(' + topbannerImage + ')' }"
    ></div>
  </div>
</template>
<script>
import { monitor } from '@/common/monitor';
import { dcepAppConfig } from '../../config/dcepApp';
export default {
  props: {
    hasOpenThatBank: {
      type: Boolean,
      default: false
    },
    currentBankHasBinding: {
      type: Boolean,
      default: false
    },
    topBannerButtonImg: {
      type: String,
      default:
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/top-banner-button-img-20220408.png'
    },
    couponImgForTOConfig: {
      type: Object,
      default:() => {}
    }
  },
  computed: {
    topbannerImage() {
      if (this.hasOpenThatBank) {
        return this.couponImgForTOConfig.hasOpen;
      }
      return this.couponImgForTOConfig.notOpen;
    }
  },
  methods: {
    toEcnyHome() {
      this.$bridge.openPage(
        'https://ecny.meituan.com/ecny/home/index.html?from=guidance_page'
      );
    },
    toDcepApp() {
      let url = '';
      if (this.phoneType === 'iphone') {
        url = dcepAppConfig.appId.scheme;
      } else {
        url = dcepAppConfig.jumpToAppAndriodScheme;
      }
      this.$bridge.openPage(url, () => {
        monitor.captureMessage(
          {
            name: '查看-打开数币App失败',
            msg: JSON.stringify(url)
          },
          {
            level: 'warn'
          }
        );
      });
    }
  }
};
</script>
<style scoped lang="less">
.top-banner {
  background-color: #fff;
  border-radius: 0.3rem;
  padding: 0.17rem 0.34rem 0.32rem 0.34rem;
  &__item {
    background: #fff7e9;
    border-radius: 0.16rem;
    margin-top: 0.15rem;
    display: flex;
    align-items: center;
    padding: 0.27rem 0.24rem 0.27rem 0.27rem;
    &__redEnvelop {
      width: 0.74rem;
      height: 0.81rem;
      background-size: auto 100%;
      background-repeat: no-repeat;
    }
    &__content {
      margin-left: 0.3rem;
      flex: 1;
      &--title {
        font-family: PingFangSC-Semibold;
        font-size: 0.28rem;
        color: #222222;
        letter-spacing: 0;
        font-weight: 600;
        line-height: 0.4rem;
      }
      &--subTitle {
        opacity: 0.4;
        font-family: PingFangSC-Regular;
        font-size: 0.2rem;
        color: #000000;
        letter-spacing: 0;
        line-height: 0.32rem;
        font-weight: 400;
      }
    }
    &__button {
      text-align: right;
      width: 1.2rem;
      height: 0.56rem;
      background-size: auto 100%;
      background-repeat: no-repeat;
    }
  }
}
.top-banner2 {
  width: 7.05rem;
  height: 1.6rem;
  background-size: auto 100%;
  background-repeat: no-repeat;
}
</style>
